import { Modal, ModalBody, ModalContent, ModalHeader, useDisclosure } from '@ds';
import { IoClose } from 'react-icons/io5';
import { useEffect } from 'react';
import { PermissionModalData } from './types';

type PermissionRequiredModalProps = {
  data: PermissionModalData;
  onClose: () => void;
};

export const PermissionRequiredModal = ({ data, onClose }: PermissionRequiredModalProps) => {
  const { isOpen, onOpen, onClose: onModalClose } = useDisclosure();

  useEffect(() => {
    if (data) {
      onOpen();
    }
  }, [data, onOpen]);

  const handleClose = () => {
    onModalClose();
    onClose();
  };

  const { scenario, roleNames, permissionName } = data;

  const getModalContent = () => {
    const roles = `${roleNames.join(', ')} ${roleNames.length > 1 ? 'roles' : 'role'}`;

    switch (scenario) {
      case 'cannotAdd':
        return {
          header: 'Permission Can Not Be Added',
          body: `The ${roles} doesn't allow adding additional permissions. Please change the role to proceed.`,
        };
      case 'cannotRemove':
        return {
          header: 'Permission Can Not Be Removed',
          body: `The selected ${roles} requires the "${permissionName}" permission. Remove the role to proceed.`,
        };
      default:
        return {
          header: 'Permission Required',
          body: 'This permission action is not allowed.',
        };
    }
  };

  const { header, body } = getModalContent();

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="xl"
      closeButton={<IoClose size={42} className="z-1000" />}
      classNames={{
        closeButton: 'text-base-10 mt-4 mr-4',
        header: 'text-hm! flex flex-col gap-4 text-base-20 py-0',
        body: 'text-base-20 py-0 my-3 gap-6',
        footer: 'flex justify-end py-0',
        base: 'py-6',
      }}
    >
      <ModalContent>
        <ModalHeader>
          <div className="flex gap-2 items-center">
            <div className="font-secondary">{header}</div>
          </div>
        </ModalHeader>
        <ModalBody>
          <p className="text-m-m">{body}</p>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
